import AdminCrud from "@/components/AdminCrud";

export default function AdminResources() {
  return (
    <AdminCrud
      endpoint="/resources"
      singular="resource"
      testIdPrefix="admin-resources"
      listColumns={[
        { key: "title", label: "Title" },
        { key: "category", label: "Category" },
        { key: "author", label: "Author" },
        { key: "published", label: "Published" },
      ]}
      fields={[
        { key: "title", label: "Title", type: "text", required: true, colSpan: 2 },
        { key: "category", label: "Category", type: "text", required: true },
        { key: "author", label: "Author" },
        { key: "published", label: "Published (YYYY-MM-DD)", type: "date" },
        { key: "url", label: "URL" },
        { key: "summary", label: "Summary", type: "textarea", required: true, colSpan: 2, rows: 4 },
      ]}
    />
  );
}
